// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.tours.RentalManagerUserPropertyToursWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserPropertyToursWebApiHandler_getCountForListings,
  RentalManagerUserPropertyToursWebApiHandler_getCountForListings_Path,
  RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders,
  RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_Path,
  RentalManagerUserPropertyToursWebApiHandler_tours,
  RentalManagerUserPropertyToursWebApiHandler_tours_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  GetToursCountForListingsRequestWebDto,
  UserPropertiesToursCountDto,
  UserPropertyToursDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface ToursParams {
  propertyId: string;
}

export type RentalManagerUserPropertyToursWebApiHandler_getCountForListings_Options = UseQueryOptions<
  Array<UserPropertiesToursCountDto>,
  unknown,
  Array<UserPropertiesToursCountDto>,
  Array<string | GetToursCountForListingsRequestWebDto>
>;

const RentalManagerUserPropertyToursWebApiHandler_getCountForListings_GetKey = (
  postData: GetToursCountForListingsRequestWebDto,
) => [RentalManagerUserPropertyToursWebApiHandler_getCountForListings_Path, postData];

/**
 * Get tours count for listings given a list of listing ids
 */
export const useRentalManagerUserPropertyToursWebApiHandler_getCountForListings = (
  postData: GetToursCountForListingsRequestWebDto,
  options: Omit<RentalManagerUserPropertyToursWebApiHandler_getCountForListings_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerUserPropertyToursWebApiHandler_getCountForListings_GetKey(postData),
    queryFn: () => RentalManagerUserPropertyToursWebApiHandler_getCountForListings(postData),
  });
};
useRentalManagerUserPropertyToursWebApiHandler_getCountForListings.getKey =
  RentalManagerUserPropertyToursWebApiHandler_getCountForListings_GetKey;

export type RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_Options = UseQueryOptions<
  Array<string>,
  unknown,
  Array<string>,
  Array<string>
>;

const RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_GetKey = () => [
  RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_Path,
];

/**
 * Get a list of supported external tour providers
 */
export const useRentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders = (
  options: Omit<
    RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_Options,
    'queryFn' | 'queryKey'
  > = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_GetKey(),
    queryFn: () => RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders(),
  });
};
useRentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders.getKey =
  RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_GetKey;

export type RentalManagerUserPropertyToursWebApiHandler_tours_Options = UseQueryOptions<
  UserPropertyToursDto,
  unknown,
  UserPropertyToursDto,
  Array<string | ToursParams>
>;

const RentalManagerUserPropertyToursWebApiHandler_tours_GetKey = (getParams: ToursParams) => [
  RentalManagerUserPropertyToursWebApiHandler_tours_Path,
  getParams,
];

/**
 * Get external tours and vr models for a property and its floor plans/units
 */
export const useRentalManagerUserPropertyToursWebApiHandler_tours = (
  getParams: ToursParams,
  options: Omit<RentalManagerUserPropertyToursWebApiHandler_tours_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerUserPropertyToursWebApiHandler_tours_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyToursWebApiHandler_tours(getParams),
  });
};
useRentalManagerUserPropertyToursWebApiHandler_tours.getKey = RentalManagerUserPropertyToursWebApiHandler_tours_GetKey;
